<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <div v-if="!loading">
            <component-header
                title="Service Request"
                :hasSearch="false"
                :hasReload="false"
                :hasCreate="true"
                @create-press="$router.push({ name: 'Create Request' })"
            />
            <b-card>
                <div class="mt-2">
                    <b-table
                        style="border-radius: 12px"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :items="servicerequests"
                        thead-class="header"
                        class="mt-3"
                        :fields="Columns"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <b-button
                                    size="sm"
                                    class="mr-2 button-circle"
                                    variant="primary"
                                    @click="
                                        navigateTo(data.item, 'View Request')
                                    "
                                >
                                    <i class="fa fa-eye"></i>
                                </b-button>
                                <b-button
                                    size="sm"
                                    class="mr-2 button-circle"
                                    style="background: #fe7b08; border: #fe7b08"
                                    variant="primary"
                                    @click="
                                        navigateTo(data.item, 'Edit Request')
                                    "
                                >
                                    <i class="fas fa-pencil-alt edit"></i>
                                </b-button>
                                <b-button
                                    size="sm"
                                    class="button-circle"
                                    variant="danger"
                                    @click="deleteReq(data)"
                                >
                                    <i class="fa fa-trash bin"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
                <div
                    style="float: right"
                    v-if="servicerequests.length > perPage"
                >
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="servicerequests.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
                <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
            </b-card>
        </div>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "servicerequestdetails",
    components: {
        ebButton,
        loader,
        ComponentHeader,
        AtomSpinner,
    },
    data() {
        return {
            perPage: 5,
            sortBy: "createdAt",
            loading: false,
            sortDesc: true,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            context: "Add",
            Columns: [
                {
                    key: "Category",
                    sortable: true,
                },
                {
                    key: "Description",
                },
                {
                    key: "Scope",
                },

                {
                    key: "Severity",
                },
                {
                    key: "Status",
                },

                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        servicerequests() {
            let data =
                this.$store.getters["servicerequest/GetServiceRequestList"];
            let ServiceRequestList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    // for (let i = 0; i < obj.items.length; i++) {
                    let arrayObj = {
                        Category: obj.name,
                        Description: obj.description,
                        Scope: obj.scope,
                        Severity: obj.severity,
                        Status: obj.status,
                        id: obj._id,
                        ...obj,
                    };
                    ServiceRequestList.push(arrayObj);
                    // }
                });
                return ServiceRequestList;
            } else {
                this.loading = false;
                return [];
            }
        },
    },
    methods: {
        navigateTo(data, pathName) {
            this.$router.push({ name: pathName, params: { data } });
        },
        async deleteReq(data) {
            this.$swal({
                title: "Delete this ServiceRequest?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("servicerequest/deleteRequest", data.item._id)
                        .then((result) => {
                            this.$toasted.success(
                                "Request Deleted Successfully",
                            );
                            this.$store
                                .dispatch(
                                    "servicerequest/fetchServicerequestList",
                                    // this.$store.getters["auth/getUserID"]
                                )
                                .catch((error) => {
                                    this.$toasted.error(error.message);
                                });
                        });
                }
            });
            this.$store.dispatch(
                "servicerequest/fetchServicerequestList",
                // this.$store.getters["auth/getUserID"]
            );
        },
    },
    async mounted() {
        // this.loading = true;
        // try {
        //     await this.$store.dispatch(
        //         "servicerequest/fetchServicerequestList",
        //     );
        // } catch (error) {
        //     this.$toasted.error(data.message);
        // } finally {
        //     this.loading = false;
        // }
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
